import DisclosureBaseController from "./disclosure_base_controller"

export default class extends DisclosureBaseController {
  static targets = ["select", "panel"]
  static values = { revealOn: String }

  get open() {
    return this.selectTarget.value === this.revealOnValue
  }
}
